import { Pagination, TablePaginationProps } from "@commonlibs";
import clsx from "clsx";

const TablePagination = ({ currentPage, totalPages, onPageChange, className, style }: TablePaginationProps): JSX.Element => {
    return (
        <Pagination
            page={currentPage}
            onChange={onPageChange}
            count={totalPages}
            siblingCount={0}
            boundaryCount={1}
            className={clsx("table-pagination", className)}
            style={style}
        />
    );
};

export default TablePagination;
